import BaseDTO from '../BaseDTO';
import type DrawRange from './DrawRange';
import type DrawElementSubType from './DrawElementSubType';
import { EItemType } from '../core/EItemType';
import type { IDrawShape } from './shape/IDrawShape';
import { DrawSubFinish } from './DrawSubFinish';

export abstract class DrawArticle extends BaseDTO {
    
    TypeName!: string;
    Range?: DrawRange;
    ProviderRef: string = "";
    SubFinish?: DrawSubFinish;
    ElementSubType?: DrawElementSubType;
    Type: EItemType = EItemType.C;
    abstract Shape?: IDrawShape;
}